module.exports = __webpack_public_path__ + "img/308.9a6d0e6e.jpg";